var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.index,staticClass:"videoBox"},[_c('img',{attrs:{"width":"100%","src":_vm.options.data.logo,"alt":""}}),_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoIcon"},[_c('img',{attrs:{"width":"40px","src":require("../../assets/play@2x.png"),"alt":""}})])
}]

export { render, staticRenderFns }